import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 45.39 38.66' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M42.8 30.93h-.45V30h.57c.3 0 .63 0 .63.43s-.34.48-.75.48m.45.27a.69.69 0 0 0 .69-.73c0-.51-.31-.76-1-.76H42v2.69h.38v-1.15h.49l.74 1.16H44l-.79-1.2z'
        />
        <path
          className='cls-1'
          d='M42.85 33.28A2.21 2.21 0 1 1 45 31.06a2.17 2.17 0 0 1-2.17 2.21m0-4.76a2.55 2.55 0 1 0 2.55 2.55 2.52 2.52 0 0 0-2.55-2.55M32.95 32.95h-5.74V24c0-2.14 0-4.89-3-4.89s-3.44 2.33-3.44 4.74v9.13h-5.71V14.49h5.5V17h.08a6 6 0 0 1 5.43-3c5.81 0 6.88 3.82 6.88 8.79zM8.6 12a3.33 3.33 0 1 1 3.32-3.33A3.32 3.32 0 0 1 8.6 12m2.87 21H5.73V14.5h5.74zM35.8 0h-33A2.82 2.82 0 0 0 0 2.79v33.08a2.82 2.82 0 0 0 2.85 2.79h33a2.83 2.83 0 0 0 2.86-2.79V2.79A2.83 2.83 0 0 0 35.8 0'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/LinkedInIcon.js